const accordionItem = document.querySelectorAll(".js-accordion-item");

accordionItem.forEach((item) => {
  const button = item.querySelector(".accordion__single-item-title button");
  button.addEventListener("click", () => {
    // Find closest accordion
    const accordion = item.closest(".features-accordion");

    // Remove active class from all accordion items
    if (accordion) {
      accordion.querySelectorAll(".js-accordion-item").forEach((item) => {
        item.classList.remove("active");
      });
    }

    // Add active class to clicked accordion item
    item.classList.add("active");

    // Find closest .js-accordion-item
    const accordionItem = item.closest(".js-accordion-item");

    // Get 'data-title' from accordionItem
    const accordionItemTitle = accordionItem.getAttribute("data-title");

    // Find closest .js-accordion-images
    const accordionImages = accordion.querySelector(".js-accordion-images");

    // Find closest .js-accordion-image with matching 'data-title'
    const accordionImage = accordionImages.querySelector(
      `[id="${accordionItemTitle}"]`
    );

    // Remove is-active class from all accordion images
    accordionImages.querySelectorAll(".is-active").forEach((image) => {
      image.classList.remove("is-active");
    });

    // Add is-active class to accordionImage
    accordionImage.classList.add("is-active");
  });
});
